import request from '../utils/request'

function dsaPost(functionName, params = {}) {
    return request.post('./DSA/index.php', { function: functionName, ...params })
}

export function loginByAccountAdmin(contact_email, contact_pwd) {
    return dsaPost('loginByAccountAdmin', { contact_email, contact_pwd })
}

export function createLoginPinCode(student_email) {
    return dsaPost('createLoginPinCode', { student_email })
}

export function verifyLoginPin(student_email, pin) {
    return dsaPost('verifyLoginPin', { student_email, pin })
}

export function getStudentDashboard(student_id) {
    return dsaPost('getStudentDashboard', { student_id })
}

export function getInstitutionDashboard(account_id, quarter_code) {
    return dsaPost('getInstitutionDashboard', { account_id, quarter_code })
}

export function getInstitutionPoster(account_id, project_code, advisor_id) {
    const params = { account_id, project_code }
    if (advisor_id) params.advisor_id = advisor_id
    return dsaPost('getInstitutionPoster', params)
}

export function getActiveQuarters() {
    return dsaPost('getActiveQuarters')
}

export function getStudentCatalog(student_id, quarter_code) {
    return dsaPost('getStudentCatalog', { student_id, quarter_code })
}

export function getStudentCatalogBatch(student_id, quarter_codes) {
    const payload = { student_id }
    if (Array.isArray(quarter_codes) && quarter_codes.length) {
        payload.quarter_codes = quarter_codes
    }
    return dsaPost('getStudentCatalogBatch', payload)
}

export function getSubjectDetail(student_id, subject_code, quarter_code) {
    return dsaPost('getSubjectDetail', { student_id, subject_code, quarter_code })
}

export function getStudentBulletins() {
    return dsaPost('getStudentBulletins')
}

export function getInstitutionCatalog(account_id, quarter_code) {
    return dsaPost('getInstitutionCatalog', { account_id, quarter_code })
}

export function getInstitutionDisciplineCatalog(account_id) {
    return dsaPost('getInstitutionDisciplineCatalog', { account_id })
}

export function getInstitutionSubjectQuota(account_id, quarter_code) {
    return dsaPost('getInstitutionSubjectQuota', { account_id, quarter_code })
}

export function submitInstitutionSubjects(account_id, quarter_code, subject_codes) {
    return dsaPost('submitInstitutionSubjects', { account_id, quarter_code, subject_codes })
}

export function registerStudentWithPass(student_id, project_id, pass_id) {
    return dsaPost('registerStudentWithPass', { student_id, project_id, pass_id })
}

export function getPassWallet(student_id) {
    return dsaPost('getPassWallet', { student_id })
}

export function redeemDsaApplicationWithPass(student_id, application_id, pass_id) {
    const params = { student_id, application_id }
    if (pass_id) params.pass_id = pass_id
    return dsaPost('redeemDsaApplicationWithPass', params)
}

export function getDsaPassProducts(student_id) {
    return dsaPost('getDsaPassProducts', { student_id })
}

export function createDsaPassOrder(student_id, pass_id) {
    // Temporary: always bind purchase to fixed DSA Pass product.
    const FIXED_DSA_PASS_ID = '6a87e0cb2e8963cade0bba67'
    return dsaPost('createDsaPassOrder', { student_id, pass_id: FIXED_DSA_PASS_ID || pass_id })
}

export function getDsaPassOrder(order_id, student_id) {
    return dsaPost('getDsaPassOrder', { order_id, student_id })
}

export function confirmDsaPassPayment(order_id, student_id) {
    return dsaPost('confirmDsaPassPayment', { order_id, student_id })
}

export function getPrepLink() {
    return dsaPost('getPrepLink')
}

export function getStudentPurchasdPasses(student_id) {
    return dsaPost('getStudentPurchasdPasses', { student_id })
}

export function requestDsaPassRefund(student_id, order_id) {
    return dsaPost('requestDsaPassRefund', { student_id, order_id })
}

export function cancelDsaPassOrder(student_id, order_id) {
    return dsaPost('cancelDsaPassOrder', { student_id, order_id })
}

export function changePassword(student_id, old_pwd, new_pwd) {
    return dsaPost('changePassword', { student_id, old_pwd, new_pwd })
}

export function getStudentAttemptsGrouped(student_id, subject_code) {
    const params = { student_id }
    if (subject_code) params.subject_code = subject_code
    return dsaPost('getStudentAttemptsGrouped', params)
}

export function getInstitutionAttemptsBySubject(account_id, subject_code) {
    return dsaPost('getInstitutionAttemptsBySubject', { account_id, subject_code })
}

export function getRegistrationsBySubject(account_id, quarter_code, subject_code) {
    return dsaPost('getRegistrationsBySubject', { account_id, quarter_code, subject_code })
}

export function getRegistrationsByStudent(account_id, quarter_code, student_id) {
    return dsaPost('getRegistrationsByStudent', { account_id, quarter_code, student_id })
}

export function searchInstitutionStudents(account_id, q) {
    return dsaPost('searchInstitutionStudents', { account_id, q })
}

export function getStudentInfo(student_id) {
    return dsaPost('getStudentInfo', { student_id })
}

export function updateStudentInfo(params) {
    return dsaPost('updateStudentInfo', params)
}

export function getTranscriptForAttempt(application_id, account_id) {
    const params = { application_id }
    if (account_id) params.account_id = account_id
    return dsaPost('getTranscriptForAttempt', params)
}

/** Official CSC score report (Phase 1). */
export function getScoreReport(params = {}) {
    return dsaPost('getScoreReport', params)
}

/** Backend-generated official transcript PDF (base64). */
export function downloadScoreReportPdf(params = {}) {
    return dsaPost('downloadScoreReportPdf', params)
}

/** Public verify by Report ID (no auth). */
export function verifyScoreReport(report_id) {
    return dsaPost('verifyScoreReport', { report_id })
}

export function getExamEntry(application_id, student_id) {
    return dsaPost('getExamEntry', { application_id, student_id })
}

export function getInstitutionSubjectsHistory(account_id) {
    return dsaPost('getInstitutionSubjectsHistory', { account_id })
}

export function cancelRegistration(application_id) {
    return dsaPost('cancelRegistration', { application_id })
}
